import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { VendorsRouteNames } from '../enums/router-names';
import { VendorsRoutePathNames } from '../enums/url-paths';

import childRoutes from './children';
import { beforeEnter } from './guards';

const App = () => import('./../App.vue');

const rootRoute: RouteRecordRaw = {
  path: buildRootURL(VendorsRoutePathNames.VENDORS),
  name: VendorsRouteNames.VENDORS_ROOT,
  meta: {
    requireAuth: true,
  },
  component: App,
  beforeEnter,
  children: childRoutes,
};

export default rootRoute;
